 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COMMON00_COVER from '@/components/Common/00_Cover'
 import COMMON01_TITLE from '@/components/Common/01_Title'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTFRONTOTHER01 from '@/components/Text/FrontOther01'
 import TEXTCHAPTER01 from '@/components/Text/Chapter01'
 import TEXTCHAPTER02 from '@/components/Text/Chapter02'
 import TEXTCHAPTER03 from '@/components/Text/Chapter03'
 import TEXTCHAPTER04 from '@/components/Text/Chapter04'
 import TEXTCHAPTER05 from '@/components/Text/Chapter05'
 import TEXTCHAPTER06 from '@/components/Text/Chapter06'
 import TEXTCHAPTER07 from '@/components/Text/Chapter07'
 import TEXTCHAPTER08 from '@/components/Text/Chapter08'
 import TEXTCHAPTER09 from '@/components/Text/Chapter09'
 import TEXTCHAPTER10 from '@/components/Text/Chapter10'
 import TEXTCHAPTER11 from '@/components/Text/Chapter11'
 import TEXTCHAPTER12 from '@/components/Text/Chapter12'
 import TEXTCHAPTER13 from '@/components/Text/Chapter13'
 import TEXTCHAPTER14 from '@/components/Text/Chapter14'
 import TEXTCHAPTER15 from '@/components/Text/Chapter15'
 import TEXTCHAPTER16 from '@/components/Text/Chapter16'
 import TEXTCHAPTER17 from '@/components/Text/Chapter17'
 import TEXTCHAPTER18 from '@/components/Text/Chapter18'
 import TEXTCHAPTER19 from '@/components/Text/Chapter19'
 import TEXTCHAPTER20 from '@/components/Text/Chapter20'
 import TEXTBACKOTHER01 from '@/components/Text/BackOther01'
 import TEXTBACKOTHER02 from '@/components/Text/BackOther02'
 import BOOK2TEXTCOVER from '@/components/Book2/Text/Cover'
 import BOOK2TEXTTITLEPAGE from '@/components/Book2/Text/TitlePage'
 import BOOK2TEXTFRONTOTHER01 from '@/components/Book2/Text/FrontOther01'
 import BOOK2TEXTCHAPTER01 from '@/components/Book2/Text/Chapter01'
 import BOOK2TEXTCHAPTER02 from '@/components/Book2/Text/Chapter02'
 import BOOK2TEXTCHAPTER03 from '@/components/Book2/Text/Chapter03'
 import BOOK2TEXTCHAPTER04 from '@/components/Book2/Text/Chapter04'
 import BOOK2TEXTCHAPTER05 from '@/components/Book2/Text/Chapter05'
 import BOOK2TEXTCHAPTER06 from '@/components/Book2/Text/Chapter06'
 import BOOK2TEXTCHAPTER07 from '@/components/Book2/Text/Chapter07'
 import BOOK2TEXTCHAPTER08 from '@/components/Book2/Text/Chapter08'
 import BOOK2TEXTCHAPTER09 from '@/components/Book2/Text/Chapter09'
 import BOOK2TEXTCHAPTER10 from '@/components/Book2/Text/Chapter10'
 import BOOK2TEXTCHAPTER11 from '@/components/Book2/Text/Chapter11'
 import BOOK2TEXTCHAPTER12 from '@/components/Book2/Text/Chapter12'
 import BOOK2TEXTCHAPTER13 from '@/components/Book2/Text/Chapter13'
 import BOOK2TEXTCHAPTER14 from '@/components/Book2/Text/Chapter14'
 import BOOK2TEXTCHAPTER15 from '@/components/Book2/Text/Chapter15'
 import BOOK2TEXTCHAPTER16 from '@/components/Book2/Text/Chapter16'
 import BOOK2TEXTCHAPTER17 from '@/components/Book2/Text/Chapter17'
 import BOOK2TEXTBACKOTHER01 from '@/components/Book2/Text/BackOther01'
 import BOOK2TEXTDEDICATION from '@/components/Book2/Text/Dedication'
 import BOOK3TEXTCOVER from '@/components/Book3/Text/Cover'
 import BOOK3TEXTTITLEPAGE from '@/components/Book3/Text/TitlePage'
 import BOOK3TEXTCASTOFCHARACTERS from '@/components/Book3/Text/CASTOFCHARACTERS'
 import BOOK3TEXTCHAPTER01 from '@/components/Book3/Text/Chapter01'
 import BOOK3TEXTCHAPTER02 from '@/components/Book3/Text/Chapter02'
 import BOOK3TEXTCHAPTER03 from '@/components/Book3/Text/Chapter03'
 import BOOK3TEXTCHAPTER04 from '@/components/Book3/Text/Chapter04'
 import BOOK3TEXTCHAPTER05 from '@/components/Book3/Text/Chapter05'
 import BOOK3TEXTCHAPTER06 from '@/components/Book3/Text/Chapter06'
 import BOOK3TEXTCHAPTER07 from '@/components/Book3/Text/Chapter07'
 import BOOK3TEXTCHAPTER08 from '@/components/Book3/Text/Chapter08'
 import BOOK3TEXTCHAPTER09 from '@/components/Book3/Text/Chapter09'
 import BOOK3TEXTCHAPTER10 from '@/components/Book3/Text/Chapter10'
 import BOOK3TEXTCHAPTER11 from '@/components/Book3/Text/Chapter11'
 import BOOK3TEXTCHAPTER12 from '@/components/Book3/Text/Chapter12'
 import BOOK3TEXTCHAPTER13 from '@/components/Book3/Text/Chapter13'
 import BOOK3TEXTCHAPTER14 from '@/components/Book3/Text/Chapter14'
 import BOOK3TEXTCHAPTER15 from '@/components/Book3/Text/Chapter15'
 import BOOK3TEXTMAORIWORDSUSEDINTHETEXT from '@/components/Book3/Text/MAORIWORDSUSEDINTHETEXT'
 import BOOK3TEXTBACKOTHER01 from '@/components/Book3/Text/BackOther01'
 import COMMONCOPYRIGHT from '@/components/Common/copyright'
 import COMMONORIMAD from '@/components/Common/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Common/00_Cover",
 			"name" : "Common/00_Cover",
 			"component" : COMMON00_COVER
 		},
 		{
 			"path" : "/Common/01_Title",
 			"name" : "Common/01_Title",
 			"component" : COMMON01_TITLE
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/FrontOther01",
 			"name" : "Text/FrontOther01",
 			"component" : TEXTFRONTOTHER01
 		},
 		{
 			"path" : "/Text/Chapter01",
 			"name" : "Text/Chapter01",
 			"component" : TEXTCHAPTER01
 		},
 		{
 			"path" : "/Text/Chapter02",
 			"name" : "Text/Chapter02",
 			"component" : TEXTCHAPTER02
 		},
 		{
 			"path" : "/Text/Chapter03",
 			"name" : "Text/Chapter03",
 			"component" : TEXTCHAPTER03
 		},
 		{
 			"path" : "/Text/Chapter04",
 			"name" : "Text/Chapter04",
 			"component" : TEXTCHAPTER04
 		},
 		{
 			"path" : "/Text/Chapter05",
 			"name" : "Text/Chapter05",
 			"component" : TEXTCHAPTER05
 		},
 		{
 			"path" : "/Text/Chapter06",
 			"name" : "Text/Chapter06",
 			"component" : TEXTCHAPTER06
 		},
 		{
 			"path" : "/Text/Chapter07",
 			"name" : "Text/Chapter07",
 			"component" : TEXTCHAPTER07
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js